// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStatasfrxeth } from "../../../icons/full/build/icon-statasfrxeth.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StatasfrxethIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStatasfrxeth.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StatasfrxethIcon.displayName = 'StatasfrxethIcon';
}

export default StatasfrxethIcon;